import styled from '@emotion/styled'
import { calcRem, metrics } from '../../__styling'

const { lg } = metrics.thenightly.margins

export const StyledChangePassword = styled('form')(({ theme }) => [
    {
        a: {
            display: 'block',
            marginBottom: calcRem(lg),
        },
    },
    // PerthNow Styling
    theme.kind === 'perthnow' && {
        paddingTop: calcRem(16),
    },
])
